import HomeEasyAccess from "../components/HomeEasyAccess/HomeEasyAccess";
import useHomeEasyAccessList from "../hooks/useHomeEasyAccessList";

const HomeEasyAccessList = () => {
  const easyAccessList = useHomeEasyAccessList();
  return (
    <ul className="mx-auto px-[20px]">
      {easyAccessList.map((easyAccess, index) => (
        <HomeEasyAccess
          key={index}
          sectionTitle={easyAccess.sectionTitle}
          briefContent={easyAccess.briefContent}
          sectionImg={easyAccess.sectionImg}
          borderTop={index !== 0}
          linkTo={easyAccess.linkTo}
        />
      ))}
    </ul>
  );
};

export default HomeEasyAccessList;
